


document.addEventListener('alpine:init', () => {

    Alpine.data('app_customer_address', (routeGet, defaultFormData, routePost, routePut, routeSetDefault, routeDelete ) => ({

        routeGet : '',
        formData: {},
        formData_default : {},
        addresses : [],
        defaultAddress : null,

        UI_displayFormEdit : false,
        UI_displayEdit : false,
        init() {
            this.routeGet = routeGet;
            this.routePost = routePost;
            this.routePut = routePut;
            this.formData_default = defaultFormData;
            this.formData = this.deepCopy(this.formData_default);

            this.routeSetDefault = routeSetDefault;
            this.routeDelete = routeDelete;
            this.loadAdresses();
        },
        loadAdresses() {

            this.addresses = [];

            axios({
                method: 'get',
                url: routeGet,
                data: {}
            }).then(response =>{

                if(response.data.success){
                    this.addresses = response.data.addresses
                    this.defaultAddress = response.data.defaultAddress
                    if(this.defaultAddress != null){
                        this.$dispatch('notifyaddresssuccess', this.defaultAddress)
                    }
                }

            });
        },
        posting : false,
        poster(){
            if(this.posting){
                return;
            }
            this.posting = true;
            this.$dispatch('notifyaddresssuccess', {}); // on envoit null pour desactiver le paiement
            axios.post(routePost, this.formData,{
            }).then(response =>{
                console.log(response);
                if(response.data.success){
                    this.addresses = response.data.addresses;
                    this.defaultAddress = response.data.defaultAddress;
                    if(this.defaultAddress != null){
                        this.$dispatch('notifyaddresssuccess', this.defaultAddress)
                    }
                    if(this.addresses.length > 0){
                        this.UI_displayEdit = false;
                        this.UI_displayFormEdit = false;
                        this.formData = this.deepCopy(this.formData_default);
                    }
                }
                this.posting = false;
            }).catch(thrown =>{
                this.posting = false;
                this.$dispatch('notifyaddresssuccess', this.defaultAddress)
            });
        },
        deepCopy(obj){
            return JSON.parse(JSON.stringify(obj));
        },
        deleting : false,
        deleteAddress(address){
            if(this.deleting){
                return;
            }
            this.deleting = true;
            this.$dispatch('notifyaddresssuccess', {}); // on envoit null pour desactiver le paiement
            axios.put(routeDelete+"/"+address.id, {},{
            }).then(response =>{
                console.log(response);
                if(response.data.success){
                    this.addresses = response.data.addresses;
                    this.defaultAddress = response.data.defaultAddress
                    if(this.defaultAddress != null){
                        this.$dispatch('notifyaddresssuccess', this.defaultAddress)
                    }
                    if(this.addresses.length > 0){
                        this.UI_displayEdit = false;
                        this.UI_displayFormEdit = false;
                        this.formData = this.deepCopy(this.formData_default);
                    }
                }
                this.deleting = false;

            }).catch(thrown =>{
                this.deleting = false;
                this.$dispatch('notifyaddresssuccess',  this.defaultAddress); // on envoit par default la default
            });
        },
        settingDefault : false,
        setDefault(address){
            if(this.settingDefault){
                return;
            }
            this.settingDefault = true;
            this.$dispatch('notifyaddresssuccess', {}); // on envoit null pour desactiver le paiement
            axios.put(routeSetDefault+"/"+address.id, {},{
            }).then(response =>{
                console.log(response);
                if(response.data.success){
                    this.addresses = response.data.addresses;
                    this.defaultAddress = response.data.defaultAddress
                    if(this.defaultAddress != null){
                        this.$dispatch('notifyaddresssuccess', this.defaultAddress)
                    }
                    if(this.addresses.length > 0){
                        this.UI_displayEdit = false;
                        this.UI_displayFormEdit = false;
                        this.formData = this.deepCopy(this.formData_default);
                    }
                }
                this.settingDefault = false;

            }).catch(thrown =>{
                this.settingDefault = false;
                this.$dispatch('notifyaddresssuccess', this.defaultAddress) // on envoit par default la default
            });
        },
        ajouterModifier(){

            if(this.UI_displayEdit){
                // ca veut dire qu'on clique sur annuler
                this.formData = this.deepCopy(this.formData_default); // on reset
                this.UI_displayFormEdit = false; // on ferme le form
            }else{
                // ca veut dire qu'on clique ajouter ou modifier
                if(this.defaultAddress != null){
                    //on a une adresse par defaut on l'edit
                    this.formData = this.defaultAddress;
                }else{
                    //on a pas  d'adresse par defaut
                    this.formData = this.deepCopy(this.formData_default);
                }
                this.UI_displayFormEdit = true;
            }


            this.UI_displayEdit = !this.UI_displayEdit;
        },
        ajouter(){
            this.UI_displayFormEdit = true;
            this.formData = this.deepCopy(this.formData_default);
        }
    }))
})





